module.exports = __webpack_public_path__ + "img/bg-3-1.a4221584.png";